import { useMemo } from 'react';
import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import { WalletType } from '~/shared';
import { StageTypes, useLayoutSelector } from '../redux';
import { useBuy } from './useBuy';

const StyledResourseContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 20px;
`;

const useShopPreview = () => {
	const activeStage = useLayoutSelector(
		(state) => state.vehicleService.activeStage,
	);
	const activeList = useLayoutSelector(
		(state) => state.vehicleService.activeList,
	);
	const activeListIndex = useLayoutSelector(
		(state) => state.vehicleService.activeListIndex,
	);
	const { handleBuy } = useBuy();

	const visible = useMemo(
		() => activeStage !== StageTypes.Category && activeListIndex !== null,
		[activeStage, activeListIndex],
	);

	const item = useMemo(
		() => activeList[activeListIndex || 0],
		[activeList, activeListIndex],
	);

	return {
		visible,
		name: item?.name,
		price: item?.price || 0,
		handlePayByCash: () => handleBuy(WalletType.Cash),
		handlePayByCard: () => handleBuy(WalletType.Bank),
		children: item?.resourceKm ? (
			<StyledResourseContainer>
				<Text style={{ fontSize: 16, color: 'rgba(255,255,255,0.5)' }}>
					Ресурс товара
				</Text>
				<Text style={{ fontSize: 16, color: '#ffffff', fontWeight: 700 }}>
					{item?.resourceKm}{' '}
					<span style={{ opacity: 0.5, fontWeight: 400 }}>км.</span>
				</Text>
			</StyledResourseContainer>
		) : null,
	};
};

export { useShopPreview };
